import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function PlayIcon() {
  return (
    /*#__PURE__*/
    // FIXME
    // eslint-disable-next-line react/forbid-elements
    _jsxs("svg", {
      width: "72",
      height: "72",
      viewBox: "0 0 72 72",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [/*#__PURE__*/_jsx("rect", {
        width: "72",
        height: "72",
        rx: "36",
        fill: "#0468FF",
        fillOpacity: "0.64"
      }), /*#__PURE__*/_jsx("path", {
        d: "M47.3519 35.168L28.5547 22.6365C27.8901 22.1934 27 22.6698 27 23.4685L27 48.5315C27 49.3302 27.8901 49.8066 28.5547 49.3635L47.3519 36.8321C47.9457 36.4362 47.9457 35.5638 47.3519 35.168Z",
        fill: "white"
      })]
    })
  );
}